import { createAction } from "@redux/actions/actionCreators";

const [useReorderProductAsset, reorderProductAsset] = createAction<{
  productUuid: string;
  /** Variant key to reorder within, or null for the product level. */
  variantKey: string | null;
  /** The product field ID of the asset-typed field (e.g. "images"). */
  productFieldId: string;
  fromUuid: string;
  toUuid: string;
}>("product/reorderAsset");

export default useReorderProductAsset;
export { reorderProductAsset };
